// extracted by mini-css-extract-plugin
export default {"root":"Sheet_root__gL3Be","scrollIndicator":"Sheet_scrollIndicator__OMAMZ","content":"Sheet_content__fH-pN"};